(() => {
  if (!document.documentElement.lang.toLowerCase().startsWith('it')) return;
  const eligible = 'p,h1,h2,h3,h4,h5,h6,li,dd,td,th,figcaption,.rte,.ag-story-caption';
  const excluded = 'script,style,code,pre,samp,kbd,nav,form,button,input,textarea,select,option,[contenteditable],[hidden],[aria-hidden="true"],[aria-live],[role="status"],[data-ag-typography-skip],.visually-hidden,.header,.header-wrapper,.breadcrumbs,.facets,.pagination,.price,.product__sku,.product__inventory,.ag26-eyebrow,.ag-newsletter-eyebrow,.caption-with-letter-spacing';
  const processed = new WeakMap();
  const pending = new Set();
  let scheduled = false;
  const nonbreakingSpace = '\u00a0';
  const glueWords = value => value.replace(/(^|[^\p{L}\p{N}_])(a|ad|e|ed|o|di|da|in|su|il|lo|la|i|gli|le|un|una|uno|al|ai|agli|alle|alla|allo|del|dei|degli|delle|della|dello|dal|dai|dagli|dalle|dalla|dallo|nel|nei|negli|nelle|nella|nello|sul|sui|sugli|sulle|sulla|sullo|con|per|tra|fra)[ \t]+(?=([\p{L}][\p{L}\p{M}'’–-]*))/giu, (match, prefix, word, nextWord) => {
    if (word.length + nextWord.length > 24) return match;
    return prefix + word + nonbreakingSpace;
  });
  const sentenceSegmenter = 'Segmenter' in Intl ? new Intl.Segmenter('it', { granularity: 'sentence' }) : null;
  const glueSentenceStarts = value => {
    if (!sentenceSegmenter) return value;
    const segments = [...sentenceSegmenter.segment(value)].map(item => item.segment);
    return segments.map((sentence, index) => {
      if (!index) return sentence;
      const previous = segments[index - 1].trimEnd();
      if (!previous.endsWith('.') || /(?:\b(?:sig|sig\.ra|sig\.na|dott|dott\.ssa|prof|prof\.ssa|avv|ing|geom|rag|dr|art|pag|nr|cod|rif|es|ecc|ca)|\b\p{Lu})\.$/iu.test(previous)) return sentence;
      return sentence.replace(/^(\s*["'«“(]?)([\p{Lu}][\p{L}\p{M}'’–-]*)([ \t]+)([\p{L}][\p{L}\p{M}'’–-]*(?:\u00a0[\p{L}][\p{L}\p{M}'’–-]*)*)(?![\p{L}\p{M}\p{N}_\/-])/u, (match, prefix, firstWord, space, nextGroup) => {
        if (firstWord.length + nextGroup.length > 24) return match;
        return prefix + firstWord + nonbreakingSpace + nextGroup;
      });
    }).join('');
  };
  const processRoot = root => {
    if (!(root instanceof Element)) return;
    const regions = root.matches(eligible) ? [root] : [...root.querySelectorAll(eligible)];
    for (const region of regions) {
      if (region.closest(excluded)) continue;
      const walker = document.createTreeWalker(region, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (node.parentElement.closest(excluded)) continue;
        const value = node.nodeValue;
        if (!value || processed.get(node) === value || !/[\p{L}]/u.test(value)) continue;
        if (/(?:https?:\/\/|www\.|[\w.+-]+@[\w.-]+\.\w+)/i.test(value)) {
          processed.set(node, value);
          continue;
        }
        const updated = glueSentenceStarts(glueWords(value));
        if (updated !== value) node.nodeValue = updated;
        processed.set(node, updated);
      }
    }
  };
  const splitHeroSentences = root => {
    if (!('Segmenter' in Intl)) return;
    const areas = root.matches?.('[data-ag-sentence-paragraphs]') ? [root] : [...root.querySelectorAll('[data-ag-sentence-paragraphs]')];
    for (const area of areas) {
      if (area.dataset.agSentencesReady || area.children.length) continue;
      const sentences = [...new Intl.Segmenter('it', { granularity: 'sentence' }).segment(area.textContent.trim())].map(item => item.segment.trim()).filter(Boolean);
      if (!sentences.length) continue;
      const fragment = document.createDocumentFragment();
      for (const sentence of sentences) {
        const paragraph = document.createElement('p');
        paragraph.textContent = sentence;
        fragment.append(paragraph);
      }
      area.replaceChildren(fragment);
      area.dataset.agSentencesReady = 'true';
    }
  };
  const apply = root => {
    if (!(root instanceof Element)) return;
    splitHeroSentences(root);
    processRoot(root);
  };
  const enqueue = root => {
    if (!(root instanceof Element)) return;
    pending.add(root.closest(eligible) || root);
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      for (const item of pending) if (item.isConnected) apply(item);
      pending.clear();
    });
  };
  const start = () => {
    apply(document.body);
    const observer = new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'characterData') {
          if (processed.get(record.target) !== record.target.nodeValue) enqueue(record.target.parentElement);
          continue;
        }
        for (const node of record.addedNodes) enqueue(node instanceof Element ? node : node.parentElement);
      }
    });
    observer.observe(document.body, { childList: true, characterData: true, subtree: true });
    document.addEventListener('shopify:section:load', event => enqueue(event.target));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
